import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppSettings } from "app/app.settings";
import { Profile } from "@app/models/profile.interface";

@Injectable({
   providedIn: "root"
})
export class ProfileService {
   private httpClient = inject(HttpClient);
   private appSettings = inject(AppSettings);

   private readonly baseUri: string;
   private readonly endpoint: string;

   constructor() {
      this.baseUri = `${this.appSettings.baseCoreApiUrl}`;
      this.endpoint = `profile`;
   }

   public getProfile(): Observable<Profile> {
      return this.httpClient.get<Profile>(`${this.baseUri}/${this.endpoint}`);
   }

   public revokeToken(): Observable<void> {
      return this.httpClient.delete<void>(
         `${this.baseUri}/${this.endpoint}/token`
      );
   }
}
